import { useContext } from "react";
import { EsusContext } from "@/contexts/EsusContext";

export function useEsus() {
	const value = useContext(EsusContext);

	return value;
}
